<template>
  <div class="cursor-pointer w-[26px] h-[26px] transition-all flex-center rounded border duration-300 group" @click.stop="toggle" tabindex="0" :class="containerClass">


    <u-icon
      name="i-ri-check-fill"
      class="w-4 h-4 transition-all duration-300 opacity-0 group-hover:opacity-50"
        :class="iconClass"
      aria-hidden="false"
    />
  </div>
</template>

<script setup>
  const selected = defineModel('selected');

  const containerClass = computed(() => {
    return selected.value ? 'bg-heroblue text-white border-transparent' : 'border-gray-300 shadow hover:border-gray-400';
  });

  const iconClass = computed(() => {
    if (selected.value) {
      return ' !opacity-100';
    }
  });

  function toggle() {
    selected.value = !selected.value;
  }
</script>
